import RecoverStep from "../recover_step";
import {voErrorClick, startRunbook} from "../../utils/recover_utils";

const TEMPLATE = 'runbook-virtualization-type';

export default class SetRunbookVirtualizationType extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        data.tmp.previousStep = fr.currentStep;
        data.render = { loadingComplete: true };
        data.recovery.virtualization = {
            type: null
        };
    }

    postRender(data, el, fr) {
        $('.error-detail a').click(function() {voErrorClick($(this), fr);});
    }

    transitionStart(data, container, fr, el) {
        data.recovery.virtualization.type = $(el).data('type');
        if (data.isAutoStopEnabled && data.recovery.virtualization.type === 'test') {
            fr.goTo('setVoVmsAutoStop');
            return;
        }
        $(".flow-selectable-button.js-start-failover").addClass("disabled");
        const voExists = checkVOExist(data.clientId, false);
        if (voExists) {
            const voDetailsUrl = '/client/details/' + data.clientId + '/1';
            tabs_goto(voDetailsUrl);
            return;
        }
        startRunbook(
            fr,
            data.clientId,
            data.runbookId,
            data.recovery.virtualization.type,
            data.password,
            null,
            function(rv, status) {
                data.recovery.virtualization.runbook = {
                    id: data.runbookId,
                    name: 'RUNBOOK'
                };
                fr.goTo('createRunbookFailover');
            },
            function(rv, status) {
                $(".flow-selectable-button.js-start-failover").removeClass("disabled");
                $.extend(data.render, {
                    hasError: true,
                    errors: rv.errors
                });
                fr.render('setRunbookVirtualizationType');
            }
        );
    }

}
